module.exports = __webpack_public_path__ + "media/fonts/KumbhSans-Regular-7473a8f760dd1e1195674a849e94aa45.ttf";